import { Component, OnInit, ViewChild } from '@angular/core';
import { MaintenanceService } from '../../../services/maintenanceService';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ExportDataService } from '../../../../shared';
import { ToastrService } from 'ngx-toastr';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatIcon } from '@angular/material/icon';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { AddEditForecastMasterComponent } from './add-edit-forecast-master/add-edit-forecast-master.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-forecast-master-table',
    templateUrl: './forecast-master-table.component.html',
    styleUrl: './forecast-master-table.component.css',
    imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, AppModalComponent, AddEditForecastMasterComponent, DatePipe]
})
export class ForecastMasterTableComponent implements OnInit {
  forecastMasterData:any = [];
  dataSource:MatTableDataSource<any>  = new MatTableDataSource([]);
  displayedColumns:Array<any> = ['Forecast_Cycle','Previous','FC_Start_Month','FC_End_Month','Start_Date','weeks','Email_Start_Date','End_date','Admin_End_Date','updatedBy','updatedAt', 'Action'];
  @ViewChild(MatPaginator,  { static: true }) paginator: MatPaginator;
  @ViewChild('addEditForsecastMasterModal') forecastModal;
  showForecastModal:boolean = false;
  selectedEditData = null;
  isEdit = false;
  forecastCycleArr:Array<any> = [];
  @ViewChild('empTbSort') empTbSort = new MatSort();
  
  constructor(public maintenanceService: MaintenanceService,private exportService: ExportDataService, private toaster: ToastrService){
  }

  ngOnInit(): void {
    this.getForecastMasterData();
    this.getForecastCycleData();
  }

  getForecastMasterData(){
    this.maintenanceService.getForecastMasterData().subscribe((res:Array<any>)=>{
      if(res && res.length> 0){
        this.forecastMasterData = res;
        this.dataSource = new MatTableDataSource(res);
        this.dataSource.sort = this.empTbSort;
        this.dataSource.paginator = this.paginator;
      }
    })
  }

  exportToExcel(){
    const exportData = [];
    this.forecastMasterData.forEach((val)=>{
      const exports = {};
      exports['Forecast Cycle'] = val.Forecast_Cycle;
      exports['Previous'] = val.Previous;
      exports['FC Start Month'] = val.FC_Start_Month;
      exports['FC End Month'] = val.FC_End_Month;
      exports['Start Date'] = val.Start_Date;
      exports['Email Start Date'] = val.Email_Start_Date;
      exports['End Date'] = val.End_date;
      exports['Admin End Date'] = val.Admin_End_Date ? val.Admin_End_Date: val.End_date;
      exports['Current Year Description'] = val.C_Description;
      exports['Future Year Description'] = val.F_Description;
      exports['Updated By'] = val.updatedBy;
      exports['Updated At'] = val.updatedAt;
      exportData.push(exports);
    })
    this.exportService.exportToExcel('Infra Forecast Master', [exportData],['Forecast Master']);
  }

  getForecastCycleData(){
    this.maintenanceService.getForecastCyclesData().subscribe((res:Array<any>)=>{
      this.forecastCycleArr = res;
    },()=>{
      this.toaster.error('Error While Fetching Data', '', {
        timeOut: 5000,
        positionClass: 'toast-top-center'
      });
    });
  }

  onAdd(){
    this.selectedEditData = null;
    this.isEdit = false;
    this.showForecastModal = true;
    this.forecastModal.show();
  }
  onEdit(element) {
    console.log("onclick of edit", element)
    this.selectedEditData = element;
    this.isEdit = true;
    this.showForecastModal = true;
    this.forecastModal.show();
  }

  hideModal(){
    this.showForecastModal = false;
    this.forecastModal.hide();
  }

  refreshTableData(){
    this.maintenanceService.setAdminDashboardUpdated(true);
    this.hideModal();
    this.getForecastMasterData();
  }

  closeModal(){
    this.showForecastModal = false;
  }

  sortData(){
    this.dataSource.sort = this.empTbSort;
  }
}
